import React from "react";

import ClockIcon from "../../../../../../assets/images/user_app/mission_page/clock_icon.svg";
import FormatIcon from "../../../../../../assets/images/user_app/mission_page/format_icon.svg";
import RewardIcon from "../../../../../../assets/images/user_app/mission_page/reward_icon.svg";


function MissionSummary({ mission }) {
    return (
        <div className="mission-summary-card">
            <MissionSummaryDetails reward={mission.reward} length={mission.length} format={mission.format} />
            <h4 className="mission-summary-description">{mission.description}</h4>
            <MissionNotices notices={mission.notices} />
        </div>
    )
}

function MissionSummaryDetails({ length, format, reward }) {
    return (
        <div className="mission-summary-details-container">
            <div className="mission-summary-details-row">
                <img src={ClockIcon} alt="clock" />
                <h3 className="mission-summary-details-row-text">{length} mins</h3>
            </div>
            <div className="mission-summary-details-row">
                <img src={FormatIcon} alt="format" />
                <h3 className="mission-summary-details-row-text">{format}</h3>
            </div>
            <div className="mission-summary-details-row">
                <img src={RewardIcon} alt="reward" />
                <h3 className="mission-summary-details-row-text">{reward}</h3>
            </div>
        </div>
    )
}

function MissionNotices({ notices }) {
    return (
        <div className="mission-summary-notices-container">
            {/* Map with index */}
            {notices && notices.map((notice, index) => (
                <div className="mission-summary-notice-text-and-divider" key={`notice-text-and-divider-${index}`}>
                    <div className="mission-summary-notice-text body-small">{notice}</div>
                    {index < notices.length - 1 &&
                        <svg className="mission-summary-notice-divider" xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="#BFBFBF">
                            <circle cx="2.5" cy="3" r="2.5" fill="#BFBFBF" />
                        </svg>
                    }
                </div>
            ))}
        </div>
    )
}

export default MissionSummary;